import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { OFFERS } from "./data";

const CartCtx = createContext(null);
const KEY = "pellet-italiana-cart";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return v && typeof v === "object" ? v : {};
  } catch {
    return {};
  }
};

export const CartProvider = ({ children }) => {
  const [qty, setQty] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(qty));
  }, [qty]);

  const value = useMemo(() => {
    const items = OFFERS.filter((o) => qty[o.id] > 0).map((o) => ({ ...o, qty: qty[o.id] }));
    const set = (id, n) => setQty((q) => {
      const next = { ...q };
      if (n > 0) next[id] = Math.min(n, 99);
      else delete next[id];
      return next;
    });
    return {
      items,
      open,
      setOpen,
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.qty * i.price, 0),
      add: (id) => set(id, (qty[id] || 0) + 1),
      set,
      clear: () => setQty({}),
    };
  }, [qty, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
